import { render, staticRenderFns } from "./SearchForm.vue?vue&type=template&id=15494897&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=ts"
export * from "./SearchForm.vue?vue&type=script&lang=ts"
import style0 from "./SearchForm.vue?vue&type=style&index=0&id=15494897&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15494897",
  null
  
)

export default component.exports